import {
  LoginInfo,
  PanelSeparator,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';

import GatedSignInInfoModule from 'components/GatedProfilePanels/GatedSignInInfoModule';
import SigninInfoModule from 'components/SigninInfoModule';
import ConnectedSecurityPanel from 'containers/ConnectedSecurityPanel';
import MFAGate from 'containers/MFAGate';
import {securityTabForwardUrl} from 'models/MFA';

const ConnectedSecurityTab: React.FC = () => {
  const logininfo = useWidgetState(Selectors.loginInfoSelector) as LoginInfo;
  const userName = useWidgetState(Selectors.userIdSelector) as string;

  return (
    <>
      <ConnectedSecurityPanel />
      <PanelSeparator />
      <MFAGate
        forwardUrl={securityTabForwardUrl}
        GatedComponent={GatedSignInInfoModule}>
        <SigninInfoModule
          email={logininfo?.email}
          userName={userName || logininfo?.userid}
        />
      </MFAGate>
    </>
  );
};

export default ConnectedSecurityTab;
